module.exports = __webpack_public_path__ + "img/NeuroviLogoSVG.2fc15973.svg";